import { defineStore } from 'pinia'
import type { User } from '~/types/user'

export const useUserStore = defineStore('rla-auth', {
  state: () => ({
    user: null as User | null,
  }),

  actions: {
    setUser(u: User) {
      this.user = u
    },
    logout() {
      this.user = null
    },
  },

  persist: true, // ✅ this is the magic
})
